module.exports = __webpack_public_path__ + "img/file-approval-survey-result.7fc56cd2.png";